import * as types from '../../components/Question/types';
import * as mathSymbols from '../../mathSymbols';

export const sequence2Questions: types.Question[] = [
  {
    numA: 0, answer: 0, sequence: 2, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 2, answer: 2, sequence: 2, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 4, answer: 4, sequence: 2, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 6, answer: 6, sequence: 2, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 8, answer: 8, sequence: 2, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 10, answer: 10, sequence: 2, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 12, answer: 12, sequence: 2, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 14, answer: 14, sequence: 2, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 16, answer: 16, sequence: 2, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 2, answer: 2, sequence: 2, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 4, answer: 4, sequence: 2, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 6, answer: 6, sequence: 2, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 8, answer: 8, sequence: 2, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 10, answer: 10, sequence: 2, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 12, answer: 12, sequence: 2, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 14, answer: 14, sequence: 2, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 16, answer: 16, sequence: 2, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 18, answer: 18, sequence: 2, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 4, answer: 4, sequence: 2, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 6, answer: 6, sequence: 2, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 8, answer: 8, sequence: 2, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 10, answer: 10, sequence: 2, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 12, answer: 12, sequence: 2, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 14, answer: 14, sequence: 2, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 16, answer: 16, sequence: 2, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 18, answer: 18, sequence: 2, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 20, answer: 20, sequence: 2, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 6, answer: 6, sequence: 2, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 8, answer: 8, sequence: 2, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 10, answer: 10, sequence: 2, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 12, answer: 12, sequence: 2, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 14, answer: 14, sequence: 2, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 16, answer: 16, sequence: 2, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 18, answer: 18, sequence: 2, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 20, answer: 20, sequence: 2, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 22, answer: 22, sequence: 2, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 8, answer: 8, sequence: 2, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 10, answer: 10, sequence: 2, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 12, answer: 12, sequence: 2, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 14, answer: 14, sequence: 2, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 16, answer: 16, sequence: 2, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 18, answer: 18, sequence: 2, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 20, answer: 20, sequence: 2, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 22, answer: 22, sequence: 2, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 24, answer: 24, sequence: 2, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question
];

export const sequence3Questions: types.Question[] = [
  {
    numA: 0, answer: 0, sequence: 3, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 3, answer: 3, sequence: 3, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 6, answer: 6, sequence: 3, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 9, answer: 9, sequence: 3, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 12, answer: 12, sequence: 3, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 15, answer: 15, sequence: 3, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 18, answer: 18, sequence: 3, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 21, answer: 21, sequence: 3, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 24, answer: 24, sequence: 3, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 3, answer: 3, sequence: 3, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 6, answer: 6, sequence: 3, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 9, answer: 9, sequence: 3, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 12, answer: 12, sequence: 3, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 15, answer: 15, sequence: 3, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 18, answer: 18, sequence: 3, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 21, answer: 21, sequence: 3, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 24, answer: 24, sequence: 3, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 27, answer: 27, sequence: 3, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 6, answer: 6, sequence: 3, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 9, answer: 9, sequence: 3, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 12, answer: 12, sequence: 3, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 15, answer: 15, sequence: 3, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 18, answer: 18, sequence: 3, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 21, answer: 21, sequence: 3, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 24, answer: 24, sequence: 3, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 27, answer: 27, sequence: 3, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 3, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 9, answer: 9, sequence: 3, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 12, answer: 12, sequence: 3, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 15, answer: 15, sequence: 3, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 18, answer: 18, sequence: 3, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 21, answer: 21, sequence: 3, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 24, answer: 24, sequence: 3, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 27, answer: 27, sequence: 3, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 3, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 33, answer: 33, sequence: 3, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 12, answer: 12, sequence: 3, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 15, answer: 15, sequence: 3, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 18, answer: 18, sequence: 3, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 21, answer: 21, sequence: 3, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 24, answer: 24, sequence: 3, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 27, answer: 27, sequence: 3, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 3, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 33, answer: 33, sequence: 3, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 36, answer: 36, sequence: 3, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question
];

export const sequence5Questions: types.Question[] = [
  {
    numA: 0, answer: 0, sequence: 5, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 5, answer: 5, sequence: 5, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 10, answer: 10, sequence: 5, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 15, answer: 15, sequence: 5, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 20, answer: 20, sequence: 5, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 25, answer: 25, sequence: 5, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 5, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 35, answer: 35, sequence: 5, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 40, answer: 40, sequence: 5, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 5, answer: 5, sequence: 5, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 10, answer: 10, sequence: 5, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 15, answer: 15, sequence: 5, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 20, answer: 20, sequence: 5, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 25, answer: 25, sequence: 5, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 5, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 35, answer: 35, sequence: 5, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 40, answer: 40, sequence: 5, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 45, answer: 45, sequence: 5, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 10, answer: 10, sequence: 5, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 15, answer: 15, sequence: 5, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 20, answer: 20, sequence: 5, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 25, answer: 25, sequence: 5, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 5, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 35, answer: 35, sequence: 5, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 40, answer: 40, sequence: 5, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 45, answer: 45, sequence: 5, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 50, answer: 50, sequence: 5, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 15, answer: 15, sequence: 5, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 20, answer: 20, sequence: 5, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 25, answer: 25, sequence: 5, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 5, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 35, answer: 35, sequence: 5, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 40, answer: 40, sequence: 5, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 45, answer: 45, sequence: 5, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 50, answer: 50, sequence: 5, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 55, answer: 55, sequence: 5, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 20, answer: 20, sequence: 5, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 25, answer: 25, sequence: 5, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 5, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 35, answer: 35, sequence: 5, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 40, answer: 40, sequence: 5, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 45, answer: 45, sequence: 5, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 50, answer: 50, sequence: 5, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 55, answer: 55, sequence: 5, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 60, answer: 60, sequence: 5, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question
];

export const sequence10Questions: types.Question[] = [
  {
    numA: 0, answer: 0, sequence: 10, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 10, answer: 10, sequence: 10, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 20, answer: 20, sequence: 10, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 10, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 40, answer: 40, sequence: 10, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 50, answer: 50, sequence: 10, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 60, answer: 60, sequence: 10, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 10, answer: 10, sequence: 10, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 20, answer: 20, sequence: 10, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 10, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 40, answer: 40, sequence: 10, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 50, answer: 50, sequence: 10, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 60, answer: 60, sequence: 10, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 70, answer: 70, sequence: 10, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 20, answer: 20, sequence: 10, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 10, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 40, answer: 40, sequence: 10, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 50, answer: 50, sequence: 10, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 60, answer: 60, sequence: 10, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 70, answer: 70, sequence: 10, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 80, answer: 80, sequence: 10, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 30, answer: 30, sequence: 10, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 40, answer: 40, sequence: 10, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 50, answer: 50, sequence: 10, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 60, answer: 60, sequence: 10, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 70, answer: 70, sequence: 10, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 80, answer: 80, sequence: 10, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 90, answer: 90, sequence: 10, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 40, answer: 40, sequence: 10, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 50, answer: 50, sequence: 10, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 60, answer: 60, sequence: 10, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 70, answer: 70, sequence: 10, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 80, answer: 80, sequence: 10, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 90, answer: 90, sequence: 10, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 100, answer: 100, sequence: 10, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question
];

export const sequence100Questions: types.Question[] = [
  {
    numA: 0, answer: 0, sequence: 100, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 100, answer: 100, sequence: 100, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 200, answer: 200, sequence: 100, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 300, answer: 300, sequence: 100, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 400, answer: 400, sequence: 100, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 500, answer: 500, sequence: 100, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 600, answer: 600, sequence: 100, format: types.Format.AdditiveSequence1, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 100, answer: 100, sequence: 100, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 200, answer: 200, sequence: 100, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 300, answer: 300, sequence: 100, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 400, answer: 400, sequence: 100, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 500, answer: 500, sequence: 100, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 600, answer: 600, sequence: 100, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 700, answer: 700, sequence: 100, format: types.Format.AdditiveSequence2, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 200, answer: 200, sequence: 100, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 300, answer: 300, sequence: 100, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 400, answer: 400, sequence: 100, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 500, answer: 500, sequence: 100, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 600, answer: 600, sequence: 100, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 700, answer: 700, sequence: 100, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 800, answer: 800, sequence: 100, format: types.Format.AdditiveSequence3, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 300, answer: 300, sequence: 100, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 400, answer: 400, sequence: 100, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 500, answer: 500, sequence: 100, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 600, answer: 600, sequence: 100, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 700, answer: 700, sequence: 100, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 800, answer: 800, sequence: 100, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 900, answer: 900, sequence: 100, format: types.Format.AdditiveSequence4, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 400, answer: 400, sequence: 100, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 500, answer: 500, sequence: 100, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 600, answer: 600, sequence: 100, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 700, answer: 700, sequence: 100, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 800, answer: 800, sequence: 100, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 900, answer: 900, sequence: 100, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question,
  {
    numA: 1000, answer: 1000, sequence: 100, format: types.Format.AdditiveSequence5, hint: types.Hint.SEQUENCE
  } as types.Question
];

export const multiply2Questions: types.Question[] = [
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question
];

export const multiply3Questions: types.Question[] = [
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const multiply4Questions: types.Question[] = [
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const multiply5Questions: types.Question[] = [
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question
];

export const multiply6Questions: types.Question[] = [
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const multiply7Questions: types.Question[] = [
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const multiply8Questions: types.Question[] = [
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const multiply9Questions: types.Question[] = [
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const multiply10Questions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question
];

export const multiply11Questions: types.Question[] = [
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question
];

export const multiply12Questions: types.Question[] = [
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question
];

export const equalGroupsObjectsQuestions: types.Question[] = [
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_0.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_1.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_2.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_3.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_4.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_5.png'), imageB: require('../../assets/images/apple_bag_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/apple_bag_6.png'), imageB: require('../../assets/images/apple_bag_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_0.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_1.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_2.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_3.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_4.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_5.png'), imageB: require('../../assets/images/cookie_plate_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/cookie_plate_6.png'), imageB: require('../../assets/images/cookie_plate_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_0.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_1.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_2.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_3.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_4.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_5.png'), imageB: require('../../assets/images/egg_box_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/egg_box_6.png'), imageB: require('../../assets/images/egg_box_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_0.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_1.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_2.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_3.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_4.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_5.png'), imageB: require('../../assets/images/flower_vase_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/flower_vase_6.png'), imageB: require('../../assets/images/flower_vase_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 0, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_0.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_1.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_2.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_3.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_4.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 6, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_5.png'), imageB: require('../../assets/images/pencil_pot_6.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 0, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_0.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 1, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_1.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 2, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_2.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 3, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_3.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 4, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_4.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 5, answer: 'No', action: 'Are the groups equal?', imageA: require('../../assets/images/pencil_pot_6.png'), imageB: require('../../assets/images/pencil_pot_5.png'), format: types.Format.EqualGroupsAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question
];

export const equalGroupsCountersQuestions: types.Question[] = [
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 1, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 2, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 3, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 4, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 5, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 6, answer: 'Yes', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 1, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 2, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 3, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 4, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 5, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 0, numB: 6, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 0, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 2, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 3, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 4, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 5, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, numB: 6, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 0, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 1, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 3, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 4, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 5, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, numB: 6, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 0, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 1, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 2, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 4, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 5, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, numB: 6, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 0, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 1, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 2, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 3, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 5, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, numB: 6, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 0, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 1, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 2, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 3, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 4, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, numB: 6, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 0, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 1, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 2, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 3, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 4, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, numB: 5, answer: 'No', action: 'Are the groups equal?', format: types.Format.EqualGroupsCountersAB, hint: types.Hint.MULTIPLE_TEN_FRAMES
  } as types.Question
];

export const timesTableFacts2Questions: types.Question[] = [
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 2, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 2, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question
];

export const timesTableFacts3Questions: types.Question[] = [
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 3, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 3, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const timesTableFacts4Questions: types.Question[] = [
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 4, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 4, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const timesTableFacts5Questions: types.Question[] = [
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 1, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 1, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 1, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 1, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 5, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 5, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question
];

export const timesTableFacts6Questions: types.Question[] = [
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 6, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 6, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const timesTableFacts7Questions: types.Question[] = [
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 7, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 7, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const timesTableFacts8Questions: types.Question[] = [
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 8, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 8, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const timesTableFacts9Questions: types.Question[] = [
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 9, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 9, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const timesTableFacts10Questions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 1, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 1, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 1, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 1, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 10, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 10, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question
];

export const timesTableFacts11Questions: types.Question[] = [
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 1, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 1, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 1, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 1, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 11, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 11, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question
];

export const timesTableFacts12Questions: types.Question[] = [
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 1, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 1, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 1, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 1, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 12, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 12, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question
];